// ==== START Custom Banner Menu Injection (AZ / TR / RU, resilient to menu/drawer IDs) ====
(function () {
  // --- Image sets ---
  const bannerImagesAz = [
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/KAMPANYALAR-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/TUM-URUNLER-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/KREATIN-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/PROTEIN-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/PRE-WORKOUT-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/ViTAMINLER-100.jpg?v=1761575487',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/AMINO-ASIT-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/KILO-VE-HACIM-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/YAG-YAKIMI-VE-KILO-VERMEK-100_1.jpg?v=1761575564',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/KAPSUL-VE-TABLETLER-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/ATISTIRMALIK-100.jpg?v=1761547902',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/SPOR-AKSESUARLARI-100-1.jpg?v=1761575334',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/GIYIM-100.jpg?v=1761547901',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/MIKRO-GIDALAR-100.jpg?v=1761547902',
  ];
  const bannerImagesTr = [
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/KAMPANYALAR_e617b980-0aab-4af3-861a-4d0e40a96ce4.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/TUM-URUNLER.png?v=1753702330',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/KREATIN_d7b71ceb-6895-4221-9e98-f67d6dbfea9d.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/PROTEIN_468ad2e6-f3c4-4b39-ab7a-e986d9f2fe62.png?v=1753702330',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/PRE-WORKOUT_833ae6eb-5daa-4677-a2bb-a5a99fff5570.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/VITAMINLER_29d6ef12-2070-4a22-9bb4-f25a7e6ac1ef.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/AMINO-ASIT_d9d2c69e-6d41-41e2-915d-4cde270472dd.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/KILO-VE-HACIM_1a361b9a-a6cd-4485-ae34-595819b1132e.png?v=1753702330',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/YAG-YAKIMI-VE-KILO-VERMEK_7094a10d-1353-427f-ab0f-e6728887db19.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/KAPSUL-VE-TABLETLER_dc938e56-23f0-4053-8663-ca5bba55b69a.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/ATISTIRMALIK_82034e16-6c55-4697-ae43-4974478c02fb.png?v=1753702330',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/SPOR-AKSESUARLARI_9a929ee2-4b6b-4eba-8a0b-032fe69c84df.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/GIYIM.png?v=1753702329',
    'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/MIKRO-GIDALAR_9e528a58-389f-4007-bb29-e61594786205.png?v=1753702330',
  ];
  const bannerImagesRu = [
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/KAMPANYALAR-RU.png?v=1754898634',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/TUM-URUNLER-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/KREATIN-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/PROTEIN-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/PRE-WORKOUT-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/SPOR-AKSESUARLARI-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/AMINO-ASIT-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/KILO-VE-HACIM-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/YAG-YAKIMI-VE-KILO-VERMEK-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/KAPSUL-VE-TABLETLER-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/ATISTIRMALIK-RU.png?v=1754898636',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/SPOR-AKSESUARLARI-RU_1.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/GIYIM-RU.png?v=1754898635',
    'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/MIKRO-GIDALAR-RU.png?v=1754898636',
  ];
  const whatsappBannerUrls = {
    az: 'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/WHATSAPP-V1-EN.png?v=1753719533',
    tr: 'https://cdn.shopify.com/s/files/1/0579/3795/2829/files/WHATSAPP-V1-TR.png?v=1749057845',
    ru: 'https://cdn.shopify.com/s/files/1/0691/8651/9084/files/WHATSAPP-V1-EN.png?v=1753719533',
  };
  const slugs = [
    '/collections/kampanya',
    '/collections/tum-urunler',
    '/collections/kreatin',
    '/collections/protein-tozu',
    '/collections/pre-workout',
    '/collections/vitaminler',
    '/collections/amino-asit',
    '/collections/karbonhidrat-tozu-ve-kilo-aldirici-gainer-toz-cesitleri',
    '/collections/yag-yakmak-ve-kilo-vermek',
    '/collections/kapsul-ve-tabletler',
    '/collections/aroma-ve-atistirmaliklar',
    '/collections/spor-aksesuarları',
    '/collections/hiq-wear-sporcu-giyim',
    '/collections/micro-gidalar',
  ];

  // --- Helpers ---
  function getLocaleAndPrefix() {
    const p = (window.location.pathname || '/').toLowerCase();
    const m = p.match(/^\/(tr|ru)(?:\/|$)/);
    const locale = m ? m[1] : 'az';
    const prefix = locale === 'tr' ? '/tr' : (locale === 'ru' ? '/ru' : '');
    return { locale, prefix };
  }
  function pickImages(locale) {
    if (locale === 'tr') return bannerImagesTr;
    if (locale === 'ru') return bannerImagesRu;
    return bannerImagesAz; // AZ uses TR-set placeholders for now
  }

  // Try a list of likely containers from common Shopify themes
  const CANDIDATE_SELECTORS = [
    '#offcanvas-menu-nav',
    '#menu-drawer', '#MenuDrawer', '.menu-drawer', 'aside.menu-drawer',
    '#nt_menu_canvas', '.nt_menu_canvas', // Kalles/Minimog-like
    '[id*="offcanvas"] nav', '[id*="offcanvas"] .menu', '[class*="offcanvas"] nav',
    '[id*="drawer"][class*="menu"]', 'aside[aria-label*="Menu"]',
    'div[role="dialog"] .menu, div[role="dialog"] nav'
  ];

  function findContainer() {
    for (const sel of CANDIDATE_SELECTORS) {
      const node = document.querySelector(sel);
      if (node) return node;
    }
    return null;
  }

  function buildWrapper(locale, prefix) {
    const imgs = pickImages(locale);
    const wrapper = document.createElement('div');
    wrapper.className = 'banner-container';
    wrapper.style.padding = '20px';

    const total = Math.min(slugs.length, imgs.length);
    for (let i = 0; i < total; i++) {
      const a = document.createElement('a');
      // encode URI component-wise to be safe with diacritics (e.g. 'aksesuarları')
      a.href = prefix + encodeURI(slugs[i]);

      a.style.display = 'block';
      a.style.margin = '12px auto';
      a.style.maxWidth = '600px';

      const img = document.createElement('img');
      img.src = imgs[i];
      img.alt = 'Banner';
      img.loading = 'lazy';
      img.style.width = '100%';
      img.style.height = '90px';
      img.style.objectFit = 'contain';
      img.style.display = 'block';
      img.style.borderRadius = '8px';
      img.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
      img.style.transition = 'transform 0.3s ease';
      img.addEventListener('mouseenter', () => { img.style.transform = 'scale(1.03)'; });
      img.addEventListener('mouseleave', () => { img.style.transform = 'scale(1)'; });

      a.appendChild(img);
      wrapper.appendChild(a);
    }

    const wa = document.createElement('a');
    wa.href = (prefix || '') + '/pages/whatsapp-link';
    wa.style.display = 'block';
    wa.style.margin = '20px auto 0 auto';
    wa.style.maxWidth = '600px';

    const waImg = document.createElement('img');
    waImg.src = whatsappBannerUrls[locale] || whatsappBannerUrls.tr;
    waImg.alt = 'WhatsApp Banner';
    waImg.loading = 'lazy';
    waImg.style.width = '100%';
    waImg.style.height = '90px';
    waImg.style.objectFit = 'contain';
    waImg.style.display = 'block';
    waImg.style.borderRadius = '8px';
    waImg.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
    waImg.style.transition = 'transform 0.3s ease';
    waImg.addEventListener('mouseenter', () => { waImg.style.transform = 'scale(1.03)'; });
    waImg.addEventListener('mouseleave', () => { waImg.style.transform = 'scale(1)'; });
    wa.appendChild(waImg);

    wrapper.appendChild(wa);
    return wrapper;
  }

  function ensureInjected() {
    const container = findContainer();
    if (!container) return;

    // Avoid duplicates (drawer can re-render)
    if (container.dataset.bannerMounted === '1') return;

    const { locale, prefix } = getLocaleAndPrefix();
    const wrapper = buildWrapper(locale, prefix);

    // Where to mount: try end of the menu body
    container.appendChild(wrapper);
    container.dataset.bannerMounted = '1';
  }

  // Try periodically in case drawer is created later
  const tickId = setInterval(ensureInjected, 500);
  setTimeout(() => clearInterval(tickId), 15000);

  // Observe DOM changes (drawer opens/closes)
  const mo = new MutationObserver(() => ensureInjected());
  mo.observe(document.documentElement || document.body, { childList: true, subtree: true });

  // Also hook into clicks on common hamburger buttons
  document.addEventListener('click', function (e) {
    const t = e.target;
    if (!t) return;
    // heuristics: buttons that open the menu
    const isHamburger = t.matches('button,[role="button"]')
      && (t.matches('[aria-controls*="menu"],[data-drawer-target*="menu"],[data-target*="menu"]')
          || /menu|drawer|offcanvas/i.test(t.getAttribute('aria-controls') || '')
          || /menu|drawer|offcanvas/i.test(t.id || '')
          || /menu|drawer|offcanvas/i.test(t.className || ''));
    if (isHamburger) {
      setTimeout(ensureInjected, 50);
      setTimeout(ensureInjected, 250);
      setTimeout(ensureInjected, 800);
    }
  });
})();
// ==== END Custom Banner Menu Injection ====








(async () => {
  // 💱 Wechselkurs (Frankfurt-Börse)
  const rate = 1.70; // manuell anpassen oder per API unten aktivieren

  // Wenn du es live holen willst, diese zwei Zeilen aktivieren:
  // const res = await fetch('https://api.frankfurter.app/latest?from=USD&to=AZN');
  // const rate = (await res.json()).rates.AZN;

  const blocks = document.querySelectorAll('.product-item-price');
  blocks.forEach(block => {
    const compareEl = block.querySelector('.product-item-price-compare s');
    const finalEl = block.querySelector('.product-item-price-final');

    const convert = (text) => {
      const match = text.replace(',', '.').match(/[\d.]+/);
      if (!match) return text;
      const usd = parseFloat(match[0]);
      if (isNaN(usd)) return text;
      const azn = (usd * rate).toFixed(2);
      return `₼${azn} AZN`;
    };

    if (compareEl) compareEl.textContent = convert(compareEl.textContent);
    if (finalEl) {
      const orig = finalEl.textContent.trim();
      finalEl.textContent = convert(orig);
    }
  });
})();
